import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import Row from '../../../containers/NotesPage/Table/Row';
import { StyledTable, TableCell } from './styles';

interface TableProps {
	allIds: number[];
}

const Table = ({ allIds }: TableProps) => (
	<StyledTable>
		<thead>
			<tr>
				<TableCell as="th">
					{/* tablet + desktop */}
					<Translate value="messages.title" />
					{/* mobile */}
					<Translate value="messages.title_and_preview" />
				</TableCell>
				<TableCell as="th">
					<Translate value="messages.preview" />
				</TableCell>
				<TableCell as="th">
					<Translate value="messages.last_update_date" />
				</TableCell>
				<TableCell as="th">
					<Translate value="messages.options" />
				</TableCell>
			</tr>
		</thead>
		<tbody>
			{allIds.length > 0
				? allIds.map(id => <Row key={id} id={id} />)
				: (
					<tr>
						<TableCell colSpan={3}>
							<Translate value="messages.no_data_found" />
						</TableCell>
					</tr>
				)
			}
		</tbody>
	</StyledTable>
);

export default Table;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotesPage/Table/index.tsx